export default {"src":"/_next/static/media/appstore.612fec9f.svg","height":18,"width":18,"blurWidth":0,"blurHeight":0};